import React, { useRef, useState } from 'react';
import { Button, Form, Image } from 'react-bootstrap';
import LoadingComponent from '../LoadingComponent';
import config from '../../Api/config';
import { useSignatureUploadMutation } from './doctorApi';
import Swal from 'sweetalert2';

const SignatureImage = ({ email, image }) => {
    const fileInputRef = useRef(null);
    const [preview, setPreview] = useState(
        image ? `${config.API_URL}/${image}` : null
    );
    const [loading, setLoading] = useState(false);
    const [signatureUpload] = useSignatureUploadMutation();

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        if (!event.target.files[0]) return;

        setLoading(true);
        const previewUrl = URL.createObjectURL(event.target.files[0]);
        setPreview(previewUrl);

        let formData = new FormData();
        formData.append('UserEmail', email);
        formData.append('SignatureImage', event.target.files[0]);

        try {
            const { data } = await signatureUpload(formData);
            if (data) {
                Swal.fire({
                    title: 'Success!',
                    text: 'Signature uploaded successfully!',
                    icon: 'success',
                    confirmButtonText: 'OK',
                    timer: 3000, // Auto close after 3 seconds
                    timerProgressBar: true,
                });
            }
        } catch (error) {
            console.error('Upload failed:', error);
            Swal.fire({
                title: 'Error!',
                text: 'Failed to upload signature',
                icon: 'error',
                confirmButtonText: 'OK',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {loading && <LoadingComponent />}

            <Image src={preview} rounded />
            <Button
                variant="primary"
                className="mt-3"
                onClick={handleButtonClick}
            >
                Modifier la signature
            </Button>
            <Form.Control
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                accept="image/*"
            />
        </div>
    );
};

export default SignatureImage;
